import { useState } from "react";
import { Settings2 } from "lucide-react";
import { cn } from "@/utils/utils";
import QueueSettings from "./QueueSettings";
import QueueAgentSettings from "./QueueAgentSettings";
import SlaSettings from "./SlaSettings";
import TicketTypeSettings from "./TicketTypeSettings";
import TicketCategorySettings from "./TicketCategorySettings";
import EscalationSettings from "./EscalationSettings";

// ============================================================================
// TICKET CONFIGURATION
// Standalone page (moved out of the Ticketing top-tab bar into
// Process Configuration → Ticket Configuration)
// ============================================================================

export default function TicketSettings() {
  const [settingsTab, setSettingsTab] =
    useState<"queues" | "agents" | "sla" | "types" | "categories" | "escalation">("queues");

  return (
    <div className="-mx-4 md:-mx-6 -mb-4 md:-mb-6 min-h-[calc(100vh-4rem)] bg-white px-4 md:px-6 flex flex-col">
      {/* Header */}
      <div className="px-0 py-4 border-b border-[#E0E0E0]">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-lg bg-[#E8DCF5] flex items-center justify-center">
            <Settings2 className="h-5 w-5 text-[#5B2C93]" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-[#2C2C2C]">Ticket Configuration</h1>
            <p className="text-sm text-[#6B6B6B]">
              Configure queues, agents, SLA policies and escalation rules
            </p>
          </div>
        </div>
      </div>

      {/* Sub-tabs */}
      <div className="border-b border-[#E0E0E0] px-0">
        <div className="flex gap-0">
          {([
            { key: "queues", label: "Queues" },
            { key: "agents", label: "Agents" },
            { key: "sla", label: "SLA Policies" },
            { key: "types", label: "Ticket Types" },
            { key: "categories", label: "Categories" },
            { key: "escalation", label: "Escalation" },
          ] as const).map((tab) => (
            <button
              key={tab.key}
              onClick={() => setSettingsTab(tab.key)}
              className={cn(
                "px-4 py-2.5 text-sm font-medium border-b-2 transition-all",
                settingsTab === tab.key
                  ? "border-[#5B2C93] text-[#5B2C93]"
                  : "border-transparent text-[#6B6B6B] hover:text-[#2C2C2C]",
              )}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1">
        {settingsTab === "queues" && <QueueSettings />}
        {settingsTab === "agents" && <QueueAgentSettings />}
        {settingsTab === "sla" && <SlaSettings />}
        {settingsTab === "types" && <TicketTypeSettings />}
        {settingsTab === "categories" && <TicketCategorySettings />}
        {settingsTab === "escalation" && <EscalationSettings />}
      </div>
    </div>
  );
}
